<template>
  <div class="right-chart-wrapper" v-loading="pending">
    <div id="right-chart"></div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array
    },
    pending: {
      type: Boolean,
      default: true
    },
    rightPieLabelData: {
      type: Array
    },
    color: {
      type: Array
    }
  },
  watch: {
    pending () {
      this.drawChart()
    }
  },
  methods: {
    drawChart () {
      if (this.pending) {
        return
      }
      const myLineChar = this.$echarts.init(document.getElementById('right-chart'))
      myLineChar.setOption({
        color: this.color,
        title: {
          text: '命中号码风险等级占比',
          textStyle: {
            color: '#3D3D3D',
            fontSize: 14
          },
          left: 24,
          top: 24
        },
        legend: {
          bottom: 10,
          icon: 'circle',
          itemWidth: 10,
          itemHeight: 10,
          itemGap: 20,
          data: this.rightPieLabelData
        },
        series: [
          {
            name: '命中号码风险等级',
            type: 'pie',
            // avoidLabelOverlap: true,
            label: {
              show: true,
              formatter: '{b}:  {d}%'
            },
            // labelLine: {
            //   show: false
            // },
            radius: '40%',
            center: ['50%', '40%'],
            data: this.data
          }
        ]
      })
      myLineChar.resize()
    }
  },
  mounted () {
    this.drawChart()
    window.addEventListener('resize', this.drawChart)
    this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('resize', this.drawChart)
    })
  }
}
</script>

<style lang="scss" scoped>
.right-chart-wrapper {
  height: 323px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 8px 0px rgba(17, 39, 98, 0.04);
  border-radius: 4px;
  width: 49%;
  display: flex;
  justify-content: center;
  #right-chart {
    width: 100%;
    height: 100%;
  }
}
</style>
